import { memo, useMemo } from 'react';
import { User } from '@Types/index';
import classNames from 'classnames';
import { Row, Col, Flex } from 'antd';
import { getGrafanaEmbedURL } from '@Features/DashboardWidgets/utils/getGrafanaEmbedUrl';
import { useAppSelector } from '@Hooks/index';
import { currentToken } from '@Store/selectors/authSelector';

import commonStyle from '../../common-desktop-styles.module.css';

interface LeaveBalanceDesktopProps {
  user: User;
  handleGoToProfilePage: () => void;
}

const LeaveBalanceDesktop: React.FC<LeaveBalanceDesktopProps> = ({
  handleGoToProfilePage,
}) => {
  const authToken = useAppSelector(currentToken);

  const grafanaAnnualRemainingURL = useMemo(
    // Grafana annual widget has id = 4
    () => getGrafanaEmbedURL('4', authToken),
    [authToken]
  );

  const grafanaRemainingPercentURL = useMemo(
    // Grafana remaining widget has id = 3
    () => getGrafanaEmbedURL('3', authToken),
    [authToken]
  );

  return (
    <div
      className={classNames(
        commonStyle.infoBlock,
        'trojan-glassphormism-box trojan-glassphormism-box-shadow'
      )}
    >
      <div className={commonStyle.header}>
        <div className={commonStyle.caption}>Leave Balance</div>
        <div className={commonStyle.link} onClick={handleGoToProfilePage}>
          Go to Leave Balance
        </div>
      </div>
      <Row className={commonStyle.row}>
        <Col span={24}>
          <div className={commonStyle.blockItem}>
            <Flex vertical gap={14} style={{ height: '100%' }}>
              <div style={{ height: '85px' }}>
                <iframe
                  className={commonStyle.iframe}
                  src={grafanaAnnualRemainingURL}
                  title="Annual & Remaining Balance"
                />
              </div>
              <div style={{ flexGrow: '1' }}>
                <iframe
                  className={commonStyle.iframe}
                  src={grafanaRemainingPercentURL}
                  title="Remaining Percent Balance"
                />
              </div>
            </Flex>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default memo(LeaveBalanceDesktop);
